import { useFormikContext } from "formik";
import React, { FC } from "react";
import { useLocale } from "../../../../contexts/localeContext";
import { TranslationKeys } from "../../../../contexts/TranslationKeys";
import { Controller } from "../../../../models/Controller";
import { WizardSummaryField, WizardSummaryLayout, WizardSummarySection } from '../../../wizard/wizard-summary-layout';

interface SummaryProps {
    onBack: (e) => void;
    controllerToReplace: Controller;
}

const Summary: FC<SummaryProps> = ({ onBack, controllerToReplace }) => {
    const { translate } = useLocale();
    const { values } = useFormikContext<any>();

    return (
        <WizardSummaryLayout onBack={onBack} submitLabel={translate.byKey(TranslationKeys.replace)}>
            <WizardSummarySection heading={translate.byKey(TranslationKeys.controllerToReplace)}>
                <WizardSummaryField label={translate.byKey(TranslationKeys.name)} value={controllerToReplace.nameOriginal} />
                <WizardSummaryField label={translate.byKey(TranslationKeys.fixedAddress)} value={controllerToReplace.fixedAddress} />
                <WizardSummaryField label={translate.byKey(TranslationKeys.ipAddress)} value={controllerToReplace.ipAddress} />
            </WizardSummarySection>

            <WizardSummarySection heading={translate.byKey(TranslationKeys.replaceWith)}>
                <WizardSummaryField label={translate.byKey(TranslationKeys.name)} value={values.name} />
                <WizardSummaryField label={translate.byKey(TranslationKeys.fixedAddress)} value={values.fixedAddress} />
                <WizardSummaryField label={translate.byKey(TranslationKeys.ipAddress)} value={values.ipAddress} />
            </WizardSummarySection>
        </WizardSummaryLayout>
    );
}

export default Summary;
